import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';
import localStorageWrapper from 'bloko/common/storage/LocalStorageWrapper';

import Report from 'src/constants/report';

export const HIDDEN_COLUMNS_FIELD = 'statportalHiddenColumnsForUser';
const SET_HIDDEN_COLUMNS_FOR_USER = 'SET_HIDDEN_COLUMNS_FOR_USER';

export type HiddenColumnsForUser = Record<Report, Record<string, boolean>>;

const INITIAL_STATE = {} as HiddenColumnsForUser;

interface PayloadTypes {
    [SET_HIDDEN_COLUMNS_FOR_USER]: {
        reportName: Report;
        reportColumns: Record<string, boolean>;
    };
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();
export const setHiddenColumnsForUser = actionCreator(SET_HIDDEN_COLUMNS_FOR_USER);

export default createReducer<Partial<HiddenColumnsForUser>, PayloadTypes>(INITIAL_STATE, {
    [SET_HIDDEN_COLUMNS_FOR_USER]: (state, { payload }) => {
        const { reportName, reportColumns } = payload;
        const newState = {
            ...state,
            [reportName]: {
                ...state[reportName],
                ...reportColumns,
            },
        };
        localStorageWrapper.setItem(HIDDEN_COLUMNS_FIELD, JSON.stringify(newState));
        return newState;
    },
});
